import React from 'react';
import {CheckCircleIcon, XCircleIcon} from "@heroicons/react/outline";

type Props = {
    value: boolean
}

function BooleanIndicator({value}: Props) {

    return value? (
        <CheckCircleIcon className="h-5 w-5 text-green-600 inline align-bottom" />
    ) : (
        <XCircleIcon className="h-5 w-5 text-red-600 inline align-bottom" />
    )
}

export default BooleanIndicator;